/**
 * ErrorFallback Styles
 * Material-UI sx styles for the ErrorFallback component
 */

export const errorFallbackStyles = {
  // Outer container that fills viewport and centers content
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh", // full viewport height
    width: "100vw", // full viewport width
    bgcolor: "background.default",
    p: 2,
    overflow: "hidden", // prevent page scrollbars
  },

  // Paper card that holds error message and buttons
  paper: {
    p: 4,
    maxWidth: 600,
    width: "100%",
    textAlign: "center",
    borderRadius: 2,
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflowY: "auto", // scroll inside Paper if content is too tall
    gap: 2, // spacing between elements
  },

  // Title text (e.g., "Something went wrong")
  title: {
    fontWeight: "bold",
    mb: 2,
  },

  // Message text (body)
  message: {
    color: "text.secondary",
    mb: 3,
  },

  // Retry button
  retryButton: {
    mb: 2,
    py: 1.5,
    fontWeight: "bold",
    textTransform: "none",
  },

  // Container for debug info / preformatted error text
  debugContainer: {
    textAlign: "left",
    fontSize: "0.75rem",
    mt: 3,
    p: 2,
    borderRadius: 1,
    bgcolor: "background.paper",
    maxHeight: 200,
    overflowY: "auto",
    overflowX: "auto",
    wordBreak: "break-word",
  },
};
